module.exports = __webpack_public_path__ + "static/img/Seguros.393e29f3.jpg";